// app__packages--scheerer.js

//==============================================================================
// External dep.
//==============================================================================
const _ = require("lodash");
//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------
const channels = require("./app__channels").channels;

//------------------------------------------------------------------------------
// Packages
//------------------------------------------------------------------------------
const googlDisplay = _.find(channels, { channel_short_name: "google-display" });
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const linkedin = _.find(channels, { channel_short_name: "linkedin" });
const indeed = _.find(channels, { channel_short_name: "indeed" });
const youtube = _.find(channels, { channel_short_name: "youtube" });
const twitter = _.find(channels, { channel_short_name: "twitter" });

module.exports = [
  {
    budget: 300,
    minClicks: 180,
    name: "Google Booster (Google Display)",
    id: "scheerer--small-google-display",
    nameShort: "A",
    description: "180 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [googlDisplay]
  },
  {
    budget: 360,
    minClicks: 108,
    name: "Indeed ",
    id: "scheerer--small-indeed",
    nameShort: "I",
    description: "108 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#58baff",
    selectedChannels: [indeed]
  },
  {
    budget: 500,
    minClicks: 300,
    name: "Google Display & Indeed ",
    id: "scheerer--small-indeed-google-display",
    nameShort: "I&G",
    description: "300 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#65ded3",
    selectedChannels: [indeed, googlDisplay]
  },

  {
    budget: 200,
    minClicks: 120,
    id: "scheerer--small-fb-insta",
    name: "Social Media Booster (Facebook, Instagram)",
    nameShort: "B",
    description: "120 qualifizierte Klicks  / 30 Tage Laufzeit",
    color: "#F79EB3",
    selectedChannels: [facebook, instagram]
  },
  {
    budget: 300,
    minClicks: 180,
    name: "Social Media Booster (Facebook, Instagram, Youtube)",
    id: "scheerer--small-fb-insta-youtube",
    nameShort: "C",
    description: "180 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B2D4F3",
    selectedChannels: [facebook, instagram, youtube]
  },
  {
    budget: 300,
    minClicks: 180,
    name: "Social Media Booster (Facebook, LinkedIn, Youtube)",
    id: "scheerer--small-fb-linkedin-youtube",
    nameShort: "L",
    description: "180 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#5978ad",
    selectedChannels: [facebook, linkedin, youtube]
  },
  {
    budget: 300,
    minClicks: 10,
    name: "LinkedIn Stellenanzeige",
    id: "scheerer--linkedin",
    nameShort: "LN",
    description: "30 Tage Laufzeit",
    color: "#0277B5",
    selectedChannels: [linkedin]
  },
  {
    budget: 300,
    minClicks: 180,
    id: "scheerer--small-fb-insta-twitter",
    name: "Social Media Booster (Facebook, Instagram, Twitter)",
    nameShort: "D",
    description: " 180 qualifizierte Klicks  / 30 Tage Laufzeit",
    color: "#F9A38A",
    selectedChannels: [facebook, instagram, twitter]
  }
];
